// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"303":"7df6cd78","505":"ef44c628","598":"fd22fd2e","644":"7d59c7e9","748":"aaaa4cc6","787":"b71c49d3"}[chunkId] + ".chunk.js";
};